import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { inr, cylShort } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function EOD() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/reports/driver-day").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-4 fade-up">
      <h1 className="font-head text-xl font-bold">End of day</h1>
      <div className="grid grid-cols-3 gap-2 text-center">
        <Card className="p-3"><div className="text-xs text-muted-foreground">Loaded</div><div className="text-2xl font-semibold tabular-nums">{s.total_loaded}</div></Card>
        <Card className="p-3"><div className="text-xs text-muted-foreground">Delivered</div><div className="text-2xl font-semibold tabular-nums">{s.total_delivered}</div></Card>
        <Card className="p-3"><div className="text-xs text-muted-foreground">Returned</div><div className="text-2xl font-semibold tabular-nums">{s.total_returned}</div></Card>
      </div>
      <Card className="p-4 space-y-2">
        <div className="flex justify-between"><span className="text-muted-foreground">Cash to hand over</span><span className="text-xl font-semibold">{inr(s.cash_total)}</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">UPI collected</span><span className="font-semibold">{inr(s.upi_total)}</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">Non-consumer sales</span><span className="font-semibold">{s.nonconsumer_count} ({inr(s.nonconsumer_amount)})</span></div>
        <div className="flex justify-between"><span className="text-muted-foreground">Empties collected</span><span className="font-semibold">{s.empties}</span></div>
      </Card>
      {s.unaccounted > 0 ? (
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800 flex gap-2" data-testid="driver-eod-redflags-list">
          <AlertTriangle className="h-5 w-5" /> <div><div className="font-medium">{s.unaccounted} cylinder(s) unaccounted</div>Please record deliveries, sales or returns so loaded = delivered + sold + returned.</div>
        </div>
      ) : (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800 flex gap-2"><CheckCircle2 className="h-5 w-5" /> All cylinders accounted for. The office will confirm your cash.</div>
      )}
    </div>
  );
}
